{
  "de": {
    "pricingPlans": {
      "error": {
        "loading": "Fehler beim Laden der Preisübersicht"
      },
      "index": {
        "headings": {
          "benefits": "Die fobizz Angebote auf einen Blick"
        },
        "newLayout": {
          "header": {
            "title": "Welches fobizz passt zu dir?",
            "subtitle": "Wir unterstützen dich dabei, deinen Unterricht interaktiver und digitaler zu gestalten"
          },
          "individualSection": {
            "title": "fobizz Einzellizenz - Individuell für dich"
          },
          "groupSection": {
            "title": "fobizz gemeinsam mit Kolleg*innen nutzen",
            "groupLicense": {
              "title": "Lizenzen für Gruppen",
              "descriptionHtml": "Die Gruppenlizenz lohnt sich bereits ab <strong>5 Personen</strong>.",
              "linkText": "Infos zur Gruppenlizenz",
              "url": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/"
            },
            "groupJoin": {
              "title": "Gruppenlizenz aktivieren",
              "description": "Deine Einrichtung hat schon eine Lizenz?",
              "instruction": "Verknüpfe hier deinen Account:"
            }
          },
          "trialSection": {
            "title": "Noch nicht sicher, was zu dir passt?",
            "description": "Aktiviere deinen kostenfreien Probemonat und teste unverbindlich den vollen Funktionsumfang der Kombi-Flatrate.",
            "placeholder": "Gutscheincode",
            "button": "Probemonat starten",
            "error": "Der Gutscheincode ist ungültig."
          }
        },
        "paragraphs": {
          "benefitsIntro": "Mit der Kombi-Flatrate kannst du alle fobizz Angebote unlimitiert nutzen. Mit einem kostenfreien Konto kannst du fobizz unverbindlich testen, einen Ausschnitt des Fortbildungskatalogs nutzen und erhältst ein monatliches Limit für die Tools. Vergleiche alle Möglichkeiten hier:"
        },
        "footer": {
          "pricingInfo": "Alle Preise pro Person inkl. deutscher Umsatzsteuer."
        },
        "limitsTable": {
          "unlimited": "Unbegrenzt"
        }
      },
      "links": {
        "getStarted": "Jetzt anmelden"
      }
    }
  }
}
